import React from 'react'
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import RevisionsPopup from './RevisionsPopup'

export default class Property extends React.Component {

  render() {
    const {icon, value, tooltipText} = this.props

    return <Row className='property'>
      <Col xs={11} >
        <span className='buttons'>
          {tooltipText ? <OverlayTrigger placement='left' overlay={<Tooltip id='tooltip'>{tooltipText}</Tooltip>}>
            <FontAwesome name={icon} size='lg' />
          </OverlayTrigger>
          : <FontAwesome name={icon} size='lg' /> }
        </span>
      { value }
      </Col>
      <Col xs={1}>
          {
            this.props.entity ? <RevisionsPopup {...this.props} /> : <span/>
          }
      </Col>
    </Row>
  }
}
